import { Phase } from '../interfaces/entities/project-configuration';
import {
  MappedConfigTreeNode,
  TaskTypeEnum,
  ConfigTask,
} from '../pages/config/project-config/project-structure-config/project-task-config/datatypes-taskconfig';

/**
 * Maps project configuration phases and tasks into a flat tree structure
 * suitable for tree-view components and hierarchical displays.
 *
 * @param projectConfiguration - Array of project phases containing milestones and task packages
 * @param tasks - Array of configuration tasks to be mapped into the tree
 * @returns Array of mapped configuration tree nodes with parent-child relationships
 */
export function mapConfigurationTree(
  projectConfiguration: Phase[],
  tasks: ConfigTask[]
): MappedConfigTreeNode[] {
  const mappedConfigTree: MappedConfigTreeNode[] = [];

  projectConfiguration?.forEach(phase => {
    const mappedPhase: MappedConfigTreeNode = {
      nodeId: `phase-${phase.id}`,
      parentNodeId: null,
      title: `${phase.nr} | ${phase.title}`,
      conditionDisplay: null,
      type: TaskTypeEnum.Group,
    };
    mappedConfigTree.push(mappedPhase);

    phase.milestones?.forEach(milestone => {
      const mappedMilestone: MappedConfigTreeNode = {
        nodeId: `milestone-${milestone.id}`,
        parentNodeId: `phase-${phase.id}`,
        title: `${milestone.nr} | ${milestone.name}`,
        conditionDisplay: null,
        type: TaskTypeEnum.Group,
      };
      mappedConfigTree.push(mappedMilestone);

      milestone.taskPackages?.forEach(taskPackage => {
        const mappedTaskPackage: MappedConfigTreeNode = {
          nodeId: `taskPackage-${taskPackage.id}`,
          parentNodeId: `milestone-${milestone.id}`,
          title: `${taskPackage.nr} | ${taskPackage.name}`,
          conditionDisplay: null,
          type: TaskTypeEnum.Group,
        };
        mappedConfigTree.push(mappedTaskPackage);

        const packageTasks = tasks.filter(task => task.taskPackageId === taskPackage.id);
        packageTasks.forEach(task => {
          const mappedTask: MappedConfigTreeNode = {
            nodeId: `task-${task.id}`,
            parentNodeId: task.parentTaskId ? `task-${task.parentTaskId}` : `taskPackage-${taskPackage.id}`,
            id: task.id,
            title: `${task.nr} | ${task.title}`,
            conditionDisplay: task.conditionDisplay,
            type: task.type,
          };
          mappedConfigTree.push(mappedTask);
        });
      });
    });
  });

  return mappedConfigTree;
}
